module.exports = __webpack_public_path__ + "static/img/xiaohongshu.64847360.png";